const MILLISEC_IN_ONE_DAY = 86400000;

// expireの値は日数を前提（例：90で来た場合は90日）
export function set(key: string, data: any, expire:number = 30) {
  const expireDate = new Date(new Date().getTime() + (expire * MILLISEC_IN_ONE_DAY));
  window.localStorage.setItem(key, JSON.stringify({ expire: expireDate, value: data }));
}

export function get(key: string) {
  const localStorageRawData:string = window.localStorage.getItem(key);
  if (!localStorageRawData) {
    return null;
  }

  const localStorageJSONData:any = JSON.parse(localStorageRawData);
  if (new Date(localStorageJSONData.expire) > new Date()) {
    return localStorageJSONData.value;
  }
  window.localStorage.removeItem(key);
  return null;
}

export function remove(key: string) {
  window.localStorage.removeItem(key);
}
